<template>
  <div>
    
    <div  >
      <a-row :gutter="gutter">
        <template v-for="(item, ri) in __items">
          <!-- 默认分两栏显示 -->
          <a-col
            class="col-height"
            v-if="
              item.name !== 'SpanLayoutField' &&
                !item.isRelatedDisplay &&
                item.perm !== 'H'
            "
            :span="24 / spanNum"
            :key="`${item.id}_${item.name}_${ri}`"
          >
            <a-form-model-item
              :prop="getFieldProp(item)"
              :name="getFieldProp(item) ? item.id : undefined"
              :key="`${item.id}_${item.name}_${ri}_${item.isRelatedRequired || false}`"
            >
              <span slot="label">
                {{ item.title }} <a-tag color="red" v-if="isStronglyRelated && item.bizAlias === 'meterType'">需要关联OA流程单</a-tag>
              </span>
              <form-design-render
                v-model="_value[item.id]"
                :mode="mode"
                :config="item"
              />
            </a-form-model-item>
            <form-design-render
              v-if="['SpanLayoutField'].includes(item.name)"
              v-model="_value"
              :mode="mode"
              :config="item"
            />
          </a-col>
        </template>
      </a-row>
    </div>
  </div>
</template>

<script>
 import FormDesignRender from '@/components/approval/layout/form/FormDesignRender'
import componentMinxins from '../ComponentMinxins'
import { postAction } from '@/api/manage'

export default {
  mixins: [componentMinxins],
  name: 'SpanLayout',
  components: {  FormDesignRender },
  props: {
    showMobile: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    children: {
      type: Array,
      default: () => {
        return []
      }
    },
    showName: {
      type: Boolean,
      default: true
    },
    spanNum: {
      type: Number,
      default: 2
    },
    gutter: {
      type: Number,
      default: 16
    },
    required: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    forms: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    dyFormItemStyle() {
      return {
        width: this.showMobile
          ? '100%'
          : `calc(100% / ${this.spanNum} - ${
              this.gutter - this.gutter / this.spanNum
            }px)`
      }
    },
    _items: {
      get() {
        return this.children
      },
      set(val) {
        this.children = val
      }
    },
    __items() {
      let result = this.children.map((child) => {
        // 保留关联字段显示逻辑
        if (['oaAssociation'].includes(child.bizAlias)) {
          child.isRelatedDisplay = true
        } else {
          if (child && child.props && child.props.relatedDisplay) {
            child.isRelatedDisplay = true
          } else {
            child.isRelatedDisplay = false
          }
        }
        // 初始化关联必填状态
        if (child && child.props && child.props.relatedRequired) {
          if (child.isRelatedRequired === undefined) {
            child.isRelatedRequired = false
          }
        }
        return child
      })
      return result
    },
    selectFormItem: {
      get() {
        return this.$store.state.selectFormItem
      },
      set(val) {
        this.$store.state.selectFormItem = val
      }
    },
    nodeMap() {
      return this.$store.state.nodeMap
    }
  },
  watch: {
    // 处理关联字段联动显隐
    value: {
      handler(val) {
        // 扁平化所有表单字段（包括普通组件、分栏组件及其嵌套字段），用于关联字段查找
        const flattenForms = this.flattenAllForms()
        const bizAliasList = flattenForms.filter((item) => item && item.bizAlias)

        // 遍历分栏内的字段，检查关联关系
        this.children.forEach((item) => {
          if (!item || !item.props) return

          // 检查关联字段（可能来自普通组件或分栏内的其他组件）
          bizAliasList.forEach((bizAlias) => {
            if (!bizAlias || !bizAlias.id) return

            // 处理关联显示
            if (
              item.props.relatedDisplay &&
              bizAlias.bizAlias == item.props.relatedField
            ) {
              if ((val[bizAlias.id] + '').trim() == (item.props.relatedValue + '').trim()) {
                item.isRelatedDisplay = false
              } else {
                item.isRelatedDisplay = true
              }
            }

            // 处理关联必填
            if (
              item.props.relatedRequired &&
              bizAlias.bizAlias == item.props.relatedField
            ) {
              const oldRelatedRequired = item.isRelatedRequired
              if ((val[bizAlias.id] + '').trim() == (item.props.relatedValue + '').trim()) {
                item.isRelatedRequired = true
              } else {
                item.isRelatedRequired = false
              }
              // 当关联必填状态变化时，更新校验规则
              if (oldRelatedRequired !== item.isRelatedRequired) {
                this.updateFieldRule(item)
              }
            }
          })
        })

        // 初始化所有必填字段的校验规则（包括静态必填和关联必填）
        this.children.forEach((item) => {
          if (!item || !item.props) return
          const needRequired = (item.props && item.props.required) || item.isRelatedRequired
          if (needRequired) {
            // 确保规则已设置
            const existingRule = this.formConfig.rules[item.id]
            if (!existingRule || existingRule.length === 0) {
              this.updateFieldRule(item)
            }
          }
        })

        // 处理表型相关逻辑
        const meterTypeItem = bizAliasList.find(v => v.bizAlias === 'meterType')
        if (meterTypeItem) {
          const meterTypeVal = (val[meterTypeItem.id] + '').trim()
          if (meterTypeVal != this.previousMeterType) {
            this.previousMeterType = meterTypeVal
            this.getProjectInfoByFormType(meterTypeVal)
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // 初始化时设置所有必填字段的校验规则
    this.initFieldRules()
  },
  data() {
    return {
      select: null,
      drag: false,
      formConfig: {
        // 数据字段
        data: {},
        // 校验规则
        rules: {}
      },
      form: {
        formId: '',
        formName: '',
        logo: {},
        formItems: [],
        process: {},
        remark: ''
      },
      isStronglyRelated: false
    }
  },
  methods: {
    // 通过表型获取项目信息判断是否显示OA强关联组件
    getProjectInfoByFormType(meterType) {
      postAction('/ztproject/getbymetertype', { meterType }).then(res => {
        const result = res.data || null
        // 判断项目类别和开始日期
        this.isStronglyRelated = result ? (['A类', 'B类', 'C类', 'D类'].includes(result.projectClass)) && new Date(result.startDate) > new Date('2024-12-02') : false
        const oaAssociationItem = this._items.find(item => item.bizAlias === 'oaAssociation')
        if (oaAssociationItem) {
            this.$set(oaAssociationItem, 'isRelatedDisplay', !this.isStronglyRelated)
        }

        // 可能需要更新其他状态或触发其他操作
      }).catch(error => {
        console.error('获取项目信息失败:', error)
      })
    },
    selectItem(cp) {
      this.selectFormItem = cp
    },
    delItem(index) {
      this.$confirm({
        title: '删除组件将会连带删除包含该组件的条件以及相关设置，是否继续?',
        okText: '确 定',
        cancelText: '取 消',
        okType: 'primary',
        onOk: () => {
          if (this._items[index].name === 'SpanLayoutField') {
            // 删除的是分栏则遍历删除分栏内所有子组件
            this._items[index].props.children.forEach((item) => {
              this.removeFormItemAbout(item)
            })
            this._items[index].props.children.length = 0
          } else {
            this.removeFormItemAbout(this._items[index])
          }
          this._items.splice(index, 1)
        },
        onCancel() {}
      })
    },
    async removeFormItemAbout(item) {
      this.nodeMap.forEach((node) => {
        // 搜寻条件，进行移除
        if (node.type === 'CONDITION') {
          node.props.groups.forEach((group) => {
            let i = group.cids.remove(item.id)
            if (i > -1) {
              // 从子条件移除
              group.conditions.splice(i, 1)
            }
          })
        }
        // 搜寻权限，进行移除
        if (
          node.type === 'ROOT' ||
          node.type === 'APPROVAL' ||
          node.type === 'CC'
        ) {
          node.props.formPerms.removeByKey('id', item.id)
        }
      })
    },
    // 获取字段的 prop（用于表单校验）
    getFieldProp(item) {
      // 只有在需要必填时才设置 prop，否则为空字符串（不进行校验）
      const needRequired = (item.props && item.props.required) || item.isRelatedRequired
      return needRequired && item.perm !== 'R' ? item.id : ''
    },
    // 更新单个字段的校验规则（用于触发响应式更新）
    updateFieldRule(item) {
      // 关键修复：同步更新父组件（FormRender）的 rules
      // 通过 $parent 向上查找 FormRender 组件（可能经过 FormDesignRender 中间层）
      let parent = this.$parent
      let maxDepth = 10 // 防止无限循环
      let formRenderRef = null

      while (parent && maxDepth > 0) {
        maxDepth--
        // 检查是否是 FormRender 组件
        if (parent.$options && parent.$options.name === 'FormRender') {
          formRenderRef = parent
          break
        }
        parent = parent.$parent
      }

      if (formRenderRef) {
        // 调用父组件的 updateFieldRule 方法，传入完整的 item 对象
        const itemForParent = {
          ...item,
          isRelatedRequired: item.isRelatedRequired
        }
        if (typeof formRenderRef.updateFieldRule === 'function') {
          formRenderRef.updateFieldRule(itemForParent)
        }

        // 清除该字段的校验状态，确保新规则生效
        this.$nextTick(() => {
          if (formRenderRef.$refs && formRenderRef.$refs.form) {
            const formInstance = formRenderRef.$refs.form
            if (formInstance && typeof formInstance.clearValidate === 'function') {
              try {
                formInstance.clearValidate([item.id])
              } catch (e) {
                console.warn('清除校验状态失败:', e)
              }
            }
          }
          // 强制更新视图以触发重新渲染
          this.$forceUpdate()
        })
      } else {
        // 如果找不到 FormRender，至少强制更新视图
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    },
    // 初始化所有字段的校验规则
    initFieldRules() {
      if (!this.children || this.children.length === 0) return
      this.children.forEach((item) => {
        if (!item || !item.props) return
        const needRequired = (item.props && item.props.required) || item.isRelatedRequired
        if (needRequired) {
          this.updateFieldRule(item)
        }
      })
    },
    // 扁平化所有表单字段（递归查找所有嵌套字段）
    flattenAllForms() {
      const result = []

      // 递归函数：扁平化表单字段数组
      const flatten = (forms) => {
        if (!Array.isArray(forms)) return
        forms.forEach((item) => {
          if (!item) return
          // 添加当前字段
          result.push(item)
          // 如果字段有 children（如 SpanLayoutField），递归处理
          if (item.props && item.props.children && Array.isArray(item.props.children)) {
            flatten(item.props.children)
          }
        })
      }

      // 优先使用传入的 forms（包含所有表单字段），否则使用 children
      const sourceForms = this.forms && this.forms.length > 0 ? this.forms : this.children
      flatten(sourceForms)

      return result
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-input {
  margin-bottom: 0 !important;
}
.col-height {
  min-height: 82px !important;
}
.choose {
  width: 100%;
  border: 1px dashed #1890ff !important;
}

.l-drag-from {
  min-height: 50px;
  background-color: rgb(245, 246, 246);
  .l-form-item {
    cursor: grab;
    background: #ffffff;
    padding: 10px;
    border: 1px solid #ebecee;
    &.selected {
      box-shadow: inset 4px 0 0 #f56c6c;
    }
    &:hover:not(.selected) {
      box-shadow: inset 4px 0 0 #bfc1c2;
    }
  }
}
.pc {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.split-width {
  width: calc(50% - 5px);
}
.l-form-header {
  font-size: small;
  color: #818181;
  text-align: left;
  position: relative;
  background-color: #fff;

  p {
    position: relative;
    margin: 0 0 10px 0;
    min-height: 19.5px;
    span {
      position: absolute;
      left: -8px;
      top: 3px;
      color: rgb(217, 0, 19);
    }
  }

  .l-option {
    position: absolute;
    top: -10px;
    right: -10px;

    i {
      font-size: large;
      cursor: pointer;
      color: #8c8c8c;
      padding: 5px;

      &:hover {
        color: #1890ff;
      }
    }
  }
}
</style>
